export const helpdeskText = {
    en: {
        diagnostics: 'Private diagnostics (administrators only)',
        guest: 'Guest request',
        guestExpired: 'This private ticket link is invalid or has expired. Please contact support.',
        guestHint: 'Keep this link private. It gives access to this request for 30 days.',
        title: 'Help & support',
        admin: 'Helpdesk tickets',
        intro: 'Need help with an application or your account? Describe what happened and what you expected. Our administrators can reply here.',
        contact: 'Other ways to get help',
        fallback: 'Create a ticket below to contact the intranet support team.',
        privacy:
            'Include the application name and steps to reproduce the problem. Remove passwords and sensitive information from screenshots.',
        newTicket: 'New request',
        subject: 'Subject',
        description: 'Describe your request',
        screenshot: 'Screenshot (optional)',
        fileHint: 'PNG or JPEG, up to 5 MB.',
        create: 'Send request',
        mine: 'My requests',
        all: 'All requests',
        empty: 'No requests yet.',
        filter: 'Status filter',
        any: 'All statuses',
        open: 'Open',
        in_progress: 'In progress',
        waiting: 'Waiting for requester',
        resolved: 'Resolved',
        closed: 'Closed',
        status: 'Status',
        information: 'Support information (visible to requester)',
        save: 'Save changes',
        comments: 'Conversation',
        comment: 'Add a comment',
        send: 'Send comment',
        support: 'Support',
        attachment: 'View screenshot',
        close: 'Close',
        error: 'The request failed. Please try again.',
        created: 'Your request was created.',
        saved: 'Changes saved.',
        fileError: 'Choose a PNG or JPEG screenshot up to 5 MB.',
        loading: 'Loading…',
        refresh: 'Refresh',
    },
    de: {
        diagnostics: 'Private Diagnoseinformationen (nur für Administratoren)',
        guest: 'Gastanfrage',
        guestExpired:
            'Dieser private Ticket-Link ist ungültig oder abgelaufen. Bitte kontaktiere den Support.',
        guestHint:
            'Bewahre diesen Link vertraulich auf. Er ermöglicht 30 Tage lang Zugriff auf diese Anfrage.',
        title: 'Hilfe & Support',
        admin: 'Helpdesk-Tickets',
        intro: 'Brauchst du Hilfe mit einer Anwendung oder deinem Konto? Beschreibe, was passiert ist und was du erwartet hast. Unsere Administratoren können hier antworten.',
        contact: 'Weitere Hilfsmöglichkeiten',
        fallback: 'Erstelle unten ein Ticket, um das Support-Team des Intranets zu kontaktieren.',
        privacy:
            'Nenne die Anwendung und die Schritte, die zum Problem führen. Entferne Passwörter und sensible Informationen aus Screenshots.',
        newTicket: 'Neue Anfrage',
        subject: 'Betreff',
        description: 'Beschreibe deine Anfrage',
        screenshot: 'Screenshot (optional)',
        fileHint: 'PNG oder JPEG, bis zu 5 MB.',
        create: 'Anfrage senden',
        mine: 'Meine Anfragen',
        all: 'Alle Anfragen',
        empty: 'Noch keine Anfragen.',
        filter: 'Statusfilter',
        any: 'Alle Status',
        open: 'Offen',
        in_progress: 'In Bearbeitung',
        waiting: 'Wartet auf Rückmeldung',
        resolved: 'Gelöst',
        closed: 'Geschlossen',
        status: 'Status',
        information: 'Support-Informationen (für Anfragende sichtbar)',
        save: 'Änderungen speichern',
        comments: 'Unterhaltung',
        comment: 'Kommentar hinzufügen',
        send: 'Kommentar senden',
        support: 'Support',
        attachment: 'Screenshot ansehen',
        close: 'Schließen',
        error: 'Die Anfrage ist fehlgeschlagen. Bitte versuche es erneut.',
        created: 'Deine Anfrage wurde erstellt.',
        saved: 'Änderungen gespeichert.',
        fileError: 'Wähle einen PNG- oder JPEG-Screenshot bis zu 5 MB.',
        loading: 'Wird geladen…',
        refresh: 'Aktualisieren',
    },
};
